module.exports = __webpack_public_path__ + "img/p&s-course5.c2f94328.jpg";